import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                button: 'toggleDetails',
                close: 'closeDetails'
            }
        }
    }

    toggleDetails(e) {
        e.preventDefault();

        const button = e.curTarget;
        const target = this.getData('target', button);
        const section = this.parent('section', e.curTarget);

        if (button.classList.contains('is-open')) {
            button.classList.remove('is-open');

            this.$(target, section)[0].classList.remove('is-open');
        } else {
            this.$('button', section).forEach(btn => {
                btn.classList.remove('is-open');
            });

            button.classList.add('is-open');

            this.$('details', section)[0] && this.$('details', section)[0].classList.remove('is-open');
            this.$('history', section)[0] && this.$('history', section)[0].classList.remove('is-open');

            this.$(target, section)[0].classList.add('is-open');
        }

        this.call('scrollTo', { target: section }, 'Scroll')
    }

    closeDetails(e) {
        e.preventDefault();

        const button = e.curTarget;
        const target = this.getData('target', button);
        const section = this.parent('section', e.curTarget);

        this.$('button', section).forEach(btn => {
            btn.classList.remove('is-open');
        });

        this.$(target, section)[0].classList.remove('is-open');

        this.call('scrollTo', { target: section }, 'Scroll')
    }
}
